var _path, _path2, _path3, _path4, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnreadNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.382 11.9509L16.4335 11.4875C16.7166 8.94366 15.0696 6.67259 12.7548 6.41498C10.44 6.15737 8.33392 8.01076 8.05082 10.5547L7.99926 11.018C7.93738 11.574 7.72713 12.1009 7.39499 12.5323L6.58108 13.5895C5.83765 14.5551 6.16058 16.016 7.21671 16.465C9.97955 17.6398 12.9943 17.9753 15.9478 17.4367C17.0768 17.2308 17.713 15.8767 17.2001 14.7712L16.6385 13.561C16.4093 13.0671 16.3201 12.5069 16.382 11.9509Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75846 18.7632C8.12462 20.2108 9.41909 21.3628 11.0709 21.5466C12.7228 21.7304 14.2388 20.8912 14.9143 19.5595",
    stroke: "#081E54",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.573 11.9386L17.639 11.3454C18.0014 8.08851 15.8927 5.18086 12.9291 4.85104C9.96542 4.52123 7.26907 6.89413 6.90661 10.1511L6.8406 10.7442C6.76138 11.4561 6.49219 12.1307 6.06696 12.683L5.02491 14.0365C4.0731 15.2728 4.48654 17.1432 5.8387 17.7181C9.37596 19.2221 13.2357 19.6517 17.0171 18.9621C18.4626 18.6986 19.2771 16.9648 18.6204 15.5495L17.9014 14.0001C17.608 13.3678 17.4937 12.6505 17.573 11.9386Z",
    stroke: "#081E54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5309 8.42969L12.2655 10.815",
    stroke: "#081E54",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 3.5,
    r: 2.5,
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadNotifications);
export default __webpack_public_path__ + "static/media/UnreadNotifications.3279e7d59c098460613ee18071a39cee.svg";
export { ForwardRef as ReactComponent };